import * as React from "react"
import DeleteConfirmationModalComponent from "./DeleteConfirmationModalComponent"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare'
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons/faSquarePlus'
import { faSquareMinus } from '@fortawesome/free-solid-svg-icons/faSquareMinus'
import { CPPart } from "../models/CPPart";
import TwoOptionModalComponent from "./TwoOptionModalComponent";
const cloneDeep = require('lodash.clonedeep')

export interface PartsListProperties {
    parts: Array<CPPart>,
    setParts: (parts: Array<CPPart>) => void;
    addPart: (partIndex: number) => void
    setSelectedPartIndex: (partIndex: number) => void;
    userIsOwner: boolean;
    limitedEditing: boolean;
    removePartInstance?: Function;
    standaloneProblem: boolean;
    answeredInAssignment: boolean
}

const PartsList = (props: PartsListProperties) => {

    const movePartUp = partIndex => {
        if (partIndex > 0) {
            var updatedParts = cloneDeep(props.parts)
            updatedParts[partIndex] = cloneDeep(props.parts[partIndex - 1])
            updatedParts[partIndex - 1] = cloneDeep(props.parts[partIndex])
            updatedParts.forEach((part, index) => {
                part.order = index + 1;
            })
            props.setParts(updatedParts)
        }
    }

    const movePartDown = partIndex => {
        if (partIndex < props.parts.length - 1) {
            var updatedParts = cloneDeep(props.parts)
            updatedParts[partIndex] = cloneDeep(props.parts[partIndex + 1])
            updatedParts[partIndex + 1] = cloneDeep(props.parts[partIndex])
            updatedParts.forEach((part, index) => {
                part.order = index + 1;
            })
            props.setParts(updatedParts)
        }
    }



    const removePart = partIndex => {
        var updatedParts = cloneDeep(props.parts)
        updatedParts.splice(partIndex, 1)
        updatedParts.forEach((part, index) => {
            part.order = index + 1;
        })
        props.setParts(updatedParts)
    }

    const editPart = (partIndex: number) => {
        props.setSelectedPartIndex(partIndex)
    }

    return (
        <div className="row">
            <div className="col">
                <b>Parts:</b>

                <ol type="a" className="ps-4 ms-0 border rounded">
                    {props.parts.length == 0 && props.userIsOwner ?
                        <span role="button" onClick={() => props.addPart(-1)}>Add Part</span> : ""}
                    {props.parts.map((part, partIndex) => {
                        return (
                            <li className="partList" key={partIndex}>
                                <div className="row my-2">
                                    <div className="col">
                                        <b>Part Text</b><br />
                                        <label className="partListText" dangerouslySetInnerHTML={{ __html: part.text || "" }}></label><br />

                                        <b>Equation:</b><br />
                                        <label className=" partListText">
                                            <p>{part.equation}</p>
                                        </label>
                                        <div className="row">
                                            <div className="col">
                                                <b>Answer Label:</b><br />
                                                <label className="partListText" dangerouslySetInnerHTML={{ __html: part.answerLabel }}>
                                                </label>
                                            </div>
                                            <div className="col">
                                                <b>Units Label:</b><br />
                                                <label className="partListText" dangerouslySetInnerHTML={{ __html: part.unitsLabel }}>
                                                </label>
                                            </div>
                                            {/*<div className="col-md-4">
                                                <b>Answer Accepted Deviation:</b>
                                                <div className="row">
                                                    <div className="col">
                                                        <input type="text" min={0} step={1} className="form-control" value={part.plusMinus + " " + (part.plusMinusIsPercent ? "%" : part.unitsLabel)} />
                                                    </div>
                                                </div>
                                            </div>*/}
                                        </div>
                                        {part.multipleChoice ?
                                            <div className="row">
                                                <b>Options</b>
                                                {part.options && part.options.map(option => {
                                                    return (
                                                        <div className="form-check" key={option.text}>
                                                            <input className="form-check-input" type="radio" checked={false} />
                                                            <label className="form-check-label" >{option.text}</label>
                                                        </div>
                                                    )
                                                })
                                                }
                                            </div>
                                            : ""}
                                    </div>
                                    <div className="col-auto">
                                        <div className="row align-items-center">
                                            <div className="col-auto">
                                                {props.userIsOwner ?
                                                    <>
                                                        {partIndex != 0 ? <a><FontAwesomeIcon icon={faAngleUp} role="button" onClick={() => movePartUp(partIndex)} /><br /></a> : ""}
                                                        {partIndex != props.parts.length - 1 ? <FontAwesomeIcon icon={faAngleDown} role="button" onClick={() => movePartDown(partIndex)} /> : ""}
                                                    </>
                                                    : ""}
                                            </div>
                                            <div className="col-auto">
                                                {props.userIsOwner ?
                                                    <>
                                                        <a>
                                                            <FontAwesomeIcon icon={faPenToSquare} size="lg" role="button" onClick={() => { editPart(partIndex); window.scrollTo(0, 0) }}></FontAwesomeIcon>
                                                        </a>&nbsp;
                                                    </>
                                                    : ""}
                                                {props.userIsOwner ?
                                                    <>
                                                        <a>
                                                            <FontAwesomeIcon icon={faSquarePlus} size="lg" role="button" onClick={() => { props.addPart(partIndex); window.scrollTo(0, 0) }}></FontAwesomeIcon>
                                                        </a>&nbsp;
                                                    </>
                                                    : ""}
                                                {(props.parts.length > 1 && ((props.standaloneProblem && props.userIsOwner) || (!props.standaloneProblem && !props.answeredInAssignment))) ?
                                                    <a><FontAwesomeIcon icon={faSquareMinus} size="lg" role="button" data-bs-toggle="modal" data-bs-target={"#removePartModal" + (partIndex)} ></FontAwesomeIcon></a>
                                                    : ""}
                                                &emsp;
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <DeleteConfirmationModalComponent
                                    itemId={"removePartModal" + (partIndex)}
                                    itemContent={"Do you want to remove problem part number " + (partIndex + 1) + "?"}
                                    deleteFunction={() => removePart(partIndex)}
                                />
                            </li>
                        )
                    })}
                </ol>
            </div>
        </div>
    )
}

export default PartsList;